import React, {useState} from 'react'
import { Link, useNavigate } from 'react-router-dom'
import bookmaker from '../../assets/icons/bookmaker-svgrepo-com.svg'
import next from '../../assets/icons/back-svgrepo-com.svg'
import SaveIcon from "../SaveIcon"
import ImageWithFallback from '../ImageWithFallback'
// import {END_POINT} from "../../../utils/constant"
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/fr"; // Importer la locale française
import { API_END_POINT, END_POINT } from '../../../utils/constant'
import axios from 'axios'
import Notification from '../../../components/Notification'
import {formatSalary} from "../../../components/DateTimeConverter/DateTimeConverter"

dayjs.extend(relativeTime);
dayjs.locale("fr");

const JobCard = ({key, item}) => {
  const  navigate = useNavigate()
  const [isSaved, setIsSaved] = useState(false)
  const [showNotif, setShowNotif] = useState({
    show: false,
    message:"Une erreur est survenue",
    variant: "danger"
  })

  const handleSaveToFavorite = (item) => {
    // const formDataToSend = new FormData();
    // formDataToSend.append("offer_id", item.id);
    // formDataToSend.append("user_id", user.id);
    // console.log("offer added to favorite", formDataToSend)
     axios.put(API_END_POINT+"/offer/addToFavorite", {
        user_id: 1, // A MODIFIER par user.id
        offer_id: 2, // A MODIFIER par 
    })
    .then((response) =>{ 
        console.log(response?.data)
        setShowNotif({...showNotif, variant: "success", message:response?.data?.message, show: true})})
    .catch((error) => setShowNotif({...showNotif, variant: "danger", message:"Une erreur est survenue", show: true}))
  };
    
  return (
    <>
        <div 
    key={key}
    className='bg-white rounded-lg overflow-hidden border py-6 px-6 transition-all ease-in hover:border-gray-400 cursor-pointer'>
        <div 
        // onClick={()=>navigate("/offre/"+item.id)} 
        className="flex items-center justify-between">
            <div 
            onClick={()=>navigate("/offre/"+item.id)} 
            className=' flex flex-row gap-3 mb-3'>
              <div className='overflow-hidden border bg-slate-50 rounded-sm flex items-center justify-center w-20 h-14 '>
                  <ImageWithFallback src={END_POINT+"/storage"+item?.user?.organisation_profile?.logo} alt="logo" defaultType='logo'  className=''/>

              </div>
              <div>
                <div className='text-level-1 flex-col justify-between col text-start'>
                {/* {END_POINT+"/storage"+item?.user?.organisation_profile?.logo} */}
                  <div className='text-lg font-semibold'>{item?.job_title}</div>
                  <span>{item?.user?.organisation_profile?.company_name}</span>
                </div>
              </div>
            </div>   
            <SaveIcon isSaved={isSaved} setIsSaved={setIsSaved} action={()=>handleSaveToFavorite(item)} />
        </div>
        <div 
        onClick={()=>navigate("/offre/"+item?.id)} 
        className="flex gap-x-2 text-primary-text">
        <div className="font-medium p-2 rounded-md bg-gray-50 border-slate-100">
          {item?.contract_type}
        </div>
        <div className="font-medium p-2 rounded-md bg-gray-50 border-slate-100">
          {item?.working_method}
        </div>
        <div className="font-medium p-2 rounded-md bg-gray-50 border-slate-100">
          {formatSalary(item?.salary) + " Ariary"}
        </div>
      </div>
        <div 
        onClick={()=>navigate("/offre/"+item?.id)} 
        className='text-level-2 '>
            <ul className='flex gap-3 mb-2'>
                <li>{item?.address}</li>
            </ul>
            <p className="mb-2 text-start " dangerouslySetInnerHTML={{ __html: item.description }} />
        <div className='flex justify-between items-center'>
        <p className=' gap-2 flex text-sm text-primary-black-300'><span> il y a {dayjs(item?.created_at).fromNow(true)}</span> - <span>{item?.applicants}</span></p>
        <button className='bg-primary-green border-none rounded-sm text-[#145926] font-semibold text-sm px-4 py-2 flex gap-2 items-center'>Voir l'offre <img src={next} alt="" className='w-4 rotate-180' /></button>
        </div>
        </div>
       
    </div>
    <Notification variant={showNotif.variant} text={showNotif.message} isOpen={showNotif.show} setIsOpen={()=>setShowNotif({...showNotif, show: false})} />
    </>

  )
}

export default JobCard